import { render, staticRenderFns } from "./writeLetterThemeContacts.vue?vue&type=template&id=8c7bc2dc&"
import script from "./writeLetterThemeContacts.vue?vue&type=script&lang=js&"
export * from "./writeLetterThemeContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports